// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"26":"merchantOperation","78":"userGuide","673":"FAQ","877":"HowToUse"}[chunkId] + "-legacy." + {"26":"4d477e44","78":"3d79345e","673":"e4050695","877":"35f8fe17"}[chunkId] + ".js";
};